import React, { useContext } from 'react';
import axios from 'axios';

export const AxiosContext = React.createContext(axios);
export const useAxiosContext = () => useContext(AxiosContext);
